enum StateTopicEnum {
  LibrarySearch = '_librarySearch',
  LibraryPage = '_libraryPage',
  LibrarySearchAndPage = '_librarySearchAndPage',
  Modal = '_modal',
  Alert = '_alert',
  User = '_user',
  User401 = '_user401',
  IsValid = 'is_valid',
  EditItem = 'edit_item',
  Refresh = 'refresh',
  CurrentUserRoles = 'user_roles',
  EditSubscription = 'edit_subscription'
}

export default StateTopicEnum;
